export default __webpack_public_path__ + "static/media/redsnowflake.10991f53.png";